import { render } from "./PopupErrorFFR.vue?vue&type=template&id=644056be&scoped=true"
import script from "./PopupErrorFFR.vue?vue&type=script&lang=js"
export * from "./PopupErrorFFR.vue?vue&type=script&lang=js"

import "./PopupErrorFFR.vue?vue&type=style&index=0&id=644056be&scoped=true&lang=css"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644056be"]])

export default __exports__